import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Injectable} from '@angular/core';

@Injectable()
export class UrlHelper {
  constructor(private auth: AuthenticationService) {
    //
  }

  public getPrefix() {
    let prefix = '';

    if (this.auth.userRole() === 'client') {
      prefix = `/clients/${this.auth.userId()}`;
    } else if (this.auth.userRole() === 'employee') {
      prefix = `/employees/${this.auth.userId()}`;
    } else if (this.auth.userRole() === 'admin') {
      prefix = `/admins/${this.auth.userId()}`;
    } else if (this.auth.userRole() === 'manufacturer') {
      prefix = `/manufacturers/${this.auth.userId()}`;
    }

    return prefix;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/url.helper.ts